// Generated by CoffeeScript 2.7.0
var slpClassPlugin;

import {
  Plugin
} from 'prosemirror-state';

import {
  history
} from 'prosemirror-history';

import {
  gapCursor
} from 'prosemirror-gapcursor';

import {
  slpBaseKeymap,
  slpKeymap
} from './keys.js';

import {
  columnResizing,
  tableEditing
} from 'prosemirror-tables';

import rules from './rules.js';

slpClassPlugin = function() {
  return new Plugin({
    props: {
      attributes: {
        class: "slp-pm"
      }
    }
  });
};

export default [rules, slpKeymap, slpBaseKeymap, slpClassPlugin(), gapCursor(), history(), columnResizing(), tableEditing()];

// for tables
document.execCommand('enableObjectResizing', false, false);

document.execCommand('enableInlineTableEditing', false, false);
